import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { fromEvent } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Component({
  selector: 'indianpix-header-container',
  templateUrl: './header-container.component.html',
  styleUrls: ['./header-container.component.scss'],
})
export class HeaderContainerComponent implements OnInit {
  @ViewChild('nav', { static: false })
  nav: ElementRef;

  menuPopup = false;

  ngOnInit(): void {
    this.handleFixedMenu();
  }

  public navToggle(): void {
    this.menuPopup = !this.menuPopup;
  }

  private handleFixedMenu(): void {
    fromEvent(document, 'scroll')
      .pipe(debounceTime(20))
      .subscribe({
        next: () => {
          if (
            document.body.scrollTop > 50 ||
            document.documentElement.scrollTop > 50
          ) {
            this.nav?.nativeElement.classList.add('scrolled');
          } else {
            this.nav?.nativeElement.classList.remove('scrolled');
          }
        },
      });
  }
}
